
import { Injectable, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Subject } from 'rxjs';
@Injectable()
export class AuthService  implements OnInit  {
    roles: Array<any> = [];
    checksprigAvailable = new Subject<any>();
    roleAccessSubscription = new Subject<any>();
    
    constructor(
        private keycloakService: KeycloakService
    ) { }
    
    redirectUrl: any;
    async ngOnInit() {
        if (await this.keycloakService.isLoggedIn()) {
          this.roles = await this.keycloakService.getUserRoles();
          const tokens = await this.keycloakService.getToken();
        }
      }

    
    async checkRoleExist(roleName:any) {       
        if (await this.keycloakService.isLoggedIn()) {
            this.roles = await this.keycloakService.getUserRoles();
            return this.roles.indexOf(roleName) < 0 ? false : true;      
          }       
    }
}